import { render, staticRenderFns } from "./channel.product.widget.vue?vue&type=template&id=c5f756c8&"
import script from "./channel.product.widget.vue?vue&type=script&lang=js&"
export * from "./channel.product.widget.vue?vue&type=script&lang=js&"
import style0 from "./channel.product.widget.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "channel.product.widget.vue"
export default component.exports